function t(){return Array.prototype.slice.call(arguments).reduce((function(t,r){return t.concat(r)}),[]).filter((function(t){return"string"==typeof t})).join(" ")}export{t as default};
//# sourceMappingURL=index.js.map
